import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { ApplicationContext } from '../ApplicationContext';
import * as styles from './DealRentTrap.css';
import { getOptions } from './options';
import { LikeIcon } from './LikeIcon';
import { DislikeIcon } from './DislikeIcon';
import { DealRentTrapFooter } from './DealRentTrapFooter';
import { DealRentTrapOferta } from './DealRentTrapOferta';
import { trackClick } from './tracking';
import { TAnalyticsOfferStatus } from '../../types/analytics';

interface IDealRentTrapOptionsProps {
  isMobile: boolean;
  analyticsOfferStatus: TAnalyticsOfferStatus;
  goToNextStep(): void;
  submitForm(): void;
}

export const DealRentTrapOptions: React.FC<IDealRentTrapOptionsProps> = ({
  isMobile,
  analyticsOfferStatus,
  goToNextStep,
  submitForm,
}) => {
  const { config } = React.useContext(ApplicationContext);
  const ofertaUrl = config.get('dealV2.ofertaUrl') as string;
  const homeownerSubscriptionPaymentEnabled = Boolean(config.get('homeownerSubscriptionPayment.enabled'));

  const optionClick = (label: string, action: string) => {
    trackClick(label, analyticsOfferStatus);
    action === 'applyDealRent' ? submitForm() : goToNextStep();
  };

  return (
    <div
      className={styles[isMobile ? 'mobile-options-wrap' : 'options-wrap']}
    >
      {getOptions(ofertaUrl, homeownerSubscriptionPaymentEnabled).map(option => (
        <div
          {...mergeStyles(
            styles['option'],
            isMobile ? styles['mobile-width'] : styles['option-width'],
          )}
          key={option.title}
        >
          <div>
            <div className={styles['option-title']}>{option.title}</div>
            <div className={styles['option-adv-list']}>
              {option.advantages.map((item, id) => (
                  <div key={id} className={styles['option-adv']}>
                    <div className={styles['icon-wrap']}>
                      <LikeIcon />
                    </div>
                    <div className={styles['option-desc']}>
                      <span className={styles['item-title']}>
                        {item.title}
                      </span>
                      <span>{item.descr}</span>
                    </div>
                  </div>
                ),
              )}
              {option.disadvantages.map(
                (item, id) => (
                  <div key={id} className={styles['option-adv']}>
                    <div className={styles['icon-wrap']}>
                      <DislikeIcon />
                    </div>
                    <div className={styles['option-desc']}>
                      <span className={styles['item-title']}>
                        {item.title}
                      </span>
                      <span>{item.descr}</span>
                    </div>
                  </div>
                ),
              )}
            </div>
            {Boolean(option.footer) && <DealRentTrapFooter {...option.footer} />}
            {Boolean(option.ofertaUrl) && <DealRentTrapOferta ofertaUrl={option.ofertaUrl} />}
          </div>
          <button
            onClick={() => optionClick(option.eventLabel, option.action)}
            className={styles['button']}
          >
            Продолжить
          </button>
        </div>
      ))}
    </div>
  );
};
